// Mobile measurement partners — v3's `app` exclusive group.
//
// AppsFlyer connects by POSTing `/oauth/appsflyer/integrate/{workspaceId}` and then selecting an
// account (`AppsFlyerIntegration.vue:118`) — an OAuth handshake with no account-level auth card,
// hence `oauthPost` rather than `oauth`. Adjust and Singular are plain credential forms.
//
// One MMP per workspace: the backend refuses a second TYPE with 409
// `INTEGRATION_MMP_ALREADY_CONNECTED` (another account of the same type is allowed), which is why
// Singular joins the same `app` group rather than standing beside it.

import type { IntegrationProvider } from '../providers.types'

export const MMP_PROVIDERS: readonly IntegrationProvider[] = [
  {
    key: 'adjust_account',
    id: 'adjust_account',
    nameKey: 'integrations.providers.adjust',
    category: 'analytics_and_tracking',
    connect: 'credential',
    configComponent: () => import('../../components/connectors/CredentialProviderConnector.vue'),
    labelFields: ['app_name', 'app_token'],
    exclusiveGroup: 'app',
    exclusiveMember: 'adjust',
    logo: 'adjust',
  },
  {
    key: 'appsflyer_account',
    id: 'appsflyer_account',
    nameKey: 'integrations.providers.appsFlyer',
    category: 'analytics_and_tracking',
    connect: 'oauthPost',
    configComponent: () => import('../../components/connectors/CredentialProviderConnector.vue'),
    labelFields: ['name'],
    exclusiveGroup: 'app',
    exclusiveMember: 'appsflyer',
    logo: 'appsflyer',
  },
  {
    key: 'singular_account',
    id: 'singular_account',
    nameKey: 'integrations.providers.singular',
    category: 'analytics_and_tracking',
    connect: 'credential',
    configComponent: () => import('../../components/connectors/CredentialProviderConnector.vue'),
    // The connection row's `name` is the constant 'Singular'; nothing about the key is listed.
    labelFields: ['name'],
    exclusiveGroup: 'app',
    exclusiveMember: 'singular',
    logo: 'singular',
  },
]
